// extracted by mini-css-extract-plugin
module.exports = {"error":"TriviaMakerPopup_error__6hvdA","errorMessage":"TriviaMakerPopup_errorMessage__fwJKa"};